<nav
  [class.navigation-rail--expanded]="isExpanded"
  class="navigation-rail"
  aria-label="Hauptnavigation">
  <div class="navigation-rail__surface">
    <div class="navigation-rail__header">
      <a
        [class.navigation-rail__brand--expanded]="isExpanded"
        class="navigation-rail__brand"
        routerLink="/"
        aria-label="Zur Startseite">
        <img
          [src]="isExpanded ? './assets/img/ci/KnOot_Logo_breit_ohne_academy.png' : './assets/img/ci/KnOot_Vector_Rohdatei_Kopf_rund.png'"
          alt="KnOot Logo"
          class="navigation-rail__logo" />
      </a>
      <button
        [attr.aria-label]="isExpanded ? 'Seitenleiste einklappen' : 'Seitenleiste ausklappen'"
        [title]="isExpanded ? 'Einklappen' : 'Ausklappen'"
        class="navigation-rail__toggle"
        type="button"
        (click)="toggleExpanded()">
        <md-icon aria-hidden="true">{{ isExpanded ? 'chevron_left' : 'chevron_right' }}</md-icon>
      </button>
    </div>


    <div class="navigation-rail__destinations">
      @for (item of primaryItems; track item.label) {
        <a
          [attr.aria-label]="item.label"
          [attr.aria-current]="isRouteActive(item) ? 'page' : null"
          [class.navigation-rail__link--active]="isRouteActive(item)"
          [routerLink]="item.href"
          [title]="item.label"
          class="navigation-rail__link">
          <span class="navigation-rail__indicator">
            <md-ripple></md-ripple>
            <md-icon>{{ item.icon }}</md-icon>
          </span>
          @if (isExpanded) {
            <span class="navigation-rail__label">{{ item.label }}</span>
          }
        </a>
      }
    </div>

    <div class="navigation-rail__secondary">
      <a
        [attr.aria-label]="accountItem.label"
        [attr.aria-current]="isRouteActive(accountItem) ? 'page' : null"
        [class.navigation-rail__link--active]="isRouteActive(accountItem)"
        [routerLink]="accountItem.href"
        [title]="accountItem.label"
        class="navigation-rail__link">
        <span class="navigation-rail__indicator">
          <md-ripple></md-ripple>
          <md-icon>{{ accountItem.icon }}</md-icon>
        </span>
        @if (isExpanded) {
          <span class="navigation-rail__label">{{ accountItem.label }}</span>
        }
      </a>

      @if (isLoggedIn()) {
        <button
          aria-label="Abmelden"
          class="navigation-rail__link navigation-rail__logout"
          title="Abmelden"
          type="button"
          (click)="logout()">
          <span class="navigation-rail__indicator">
            <md-ripple></md-ripple>
            <md-icon>logout</md-icon>
          </span>
          @if (isExpanded) {
            <span class="navigation-rail__label">Abmelden</span>
          }
        </button>
      }
    </div>
  </div>
</nav>

<nav class="navigation-bar" aria-label="Mobile Navigation">
  <div class="navigation-bar__surface">
    @for (item of mobileItems; track item.label) {
      <a
        [attr.aria-current]="isRouteActive(item) ? 'page' : null"
        [class.navigation-bar__item--active]="isRouteActive(item)"
        [routerLink]="item.href"
        [title]="item.label"
        class="navigation-bar__item">
        <span class="navigation-bar__indicator">
          <md-ripple></md-ripple>
          <md-icon>{{ item.icon }}</md-icon>
        </span>
        <span class="navigation-bar__label">{{ item.label }}</span>
      </a>
    }
  </div>
</nav>
